/*
 *   File : aprrove-kyc.js
 *   Author URI : https://evoqins.com
 *   Description : UI element which asks for approving kyc.
 *   Integrations : null
 *   Version : v1.1
 */
/* import packages */
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

/* import components */
import { GradientButton } from "../Cta";
import { Icon } from "../Icon";

/* import styles */
import style from "../../Styles/Components/delete.module.scss";
import { closeModal } from "../../Helper/helper-function";

/* import helper */

const OnboardingCheckModal = (props) => {
    const [showStatus, setShowStatus] = useState(false);
    useEffect(() => {
        var my_modal = document.getElementById("onboarding-check");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
        //eslint-disable-next-line
    }, [props.close]);


    const _handleDelete = async () => {
        const response = await props.check();
        if (response === true) {
            if(props.type <= 2){
                setShowStatus(true)
            }else{
                closeModal("onboarding-check")
            }
        } else {

        }
    }

    return (
        <div className={`modal fade ${style.e_approve_kyc}`}
            id="onboarding-check"
            tabIndex="-1"
            aria-labelledby="onboarding-check"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-white text-center d-flex align-items-center padding-32px-all ${style.e_content} `}>
                    <div className="col-12 d-flex justify-content-between">

                        <Icon icon="close"
                            size={24}
                            className="cursor-pointer ms-auto e-modal-close-btn"
                            data-bs-dismiss="modal"
                            id="close-modal" />
                    </div>
                    <img draggable={false} src={require("../../Assets/Images/Modal/kyc-success.png")}
                        alt="Kyc success"
                        width={72}
                        height={72}
                    />


                    {
                        showStatus === true ?
                            <Fragment>
                                {
                                    Object.keys(props.statusData).map((item) => {
                                        return (
                                            <p className="color-outer-space e-poppins-regular e-font-14 mt-2 mb-0 px-5 capitalized-text">
                                                {item} : {props.statusData[`${item}`]}
                                            </p>
                                        )
                                    })
                                }

                                <div className="d-flex  justify-content-center margin-32px-top margin-32px-bottom w-100">

                                    <GradientButton label="Close"
                                        className="padding-12px-tb e-font-16 px-4"
                                        cancel="modal"
                                        onPress={props.updateList}
                                        hide_loader />
                                </div>
                            </Fragment>
                            :
                            <Fragment>
                                <h6 className="color-eerie-black e-poppins-medium e-font-18 mt-4 mb-0">
                                    {props.title}
                                </h6>
                                <p className="color-outer-space e-poppins-regular e-font-14 mt-2 mb-0 px-5">
                                    {props.description}
                                </p>

                                <div className="d-flex  justify-content-center margin-32px-top margin-32px-bottom w-100">

                                    <GradientButton label="Continue"
                                        className="padding-12px-tb e-font-16 px-4"
                                        hide_loader={!props.loader}
                                        loading={props.loader}
                                        onPress={_handleDelete} />
                                </div>
                            </Fragment>
                    }
                </div>
            </div>
        </div>
    )
}


OnboardingCheckModal.defaultProps = {
    close: () => { }
}

export default OnboardingCheckModal